/* eslint-disable no-console */
/* eslint-disable react/no-is-mounted */
import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import io from 'socket.io-client';
import get from 'lodash/get';
import { SET_ACTION_MESSAGE } from '../redux/types';
import { getParams } from '../util';
import host from '../util/host';
import router from '../util/router';
import SessionStorageServices from '../util/sessionStorageServices';

dayjs.extend(utc);
dayjs.extend(timezone);

class IdentityCheck extends React.PureComponent {
  constructor(props) {
    super(props);
    this.uid = '';
    this.identityCheckInitiated = false;
    this.excludePages = ['timeout', 'completed'];
    this._connectSocket = this._connectSocket.bind(this);
  }

  async componentDidMount() {
    const uid = getParams('uid');

    if (!this.identityCheckInitiated && uid) {
      this.uid = uid;
      if (this._shouldStartSocketConnection()) {
        this._connectSocket.call(this);
        this.identityCheckInitiated = true;
        console.log('IDENTITY CHECK::: Initiating Identity Check in Component Did Mount.');
        console.log('IDENTITY CHECK::: UID: ', this.uid);
      }
    }
  }

  componentDidUpdate() {
    const uid = getParams('uid');

    if (!this.identityCheckInitiated && uid) {
      this.uid = uid;
      if (this._shouldStartSocketConnection()) {
        this._connectSocket.call(this);
        this.identityCheckInitiated = true;
        console.log('IDENTITY CHECK::: Initiating Identity Check in Component Did Update.');
        console.log('IDENTITY CHECK::: UID: ', this.uid);
      }
    }
  }

  _shouldStartSocketConnection() {
    const { isIdentityCheckEnabled } = this.props;
    const currentPath = window.location.pathname.replace('/', '');
    const pagePath = this.excludePages.filter((path) => path.match(currentPath)).length;

    // Checks if the identity is valid or not based on uid.
    const identity = SessionStorageServices.getIdentity(getParams('uid'));
    if (identity === 'invalid' || pagePath) {
      return false;
    }
    return isIdentityCheckEnabled;
  }

  // eslint-disable-next-line class-methods-use-this
  _getUserData() {
    return {
      userAgent: navigator.userAgent,
      sourcePage: window.location.pathname,
      sourceUrl: window.location.search,
      userTimeZone: dayjs(),
      currentDateTime: dayjs.tz.guess(),
      feature: 'identity',
    };
  }

  _connectSocket() {
    const { WS_BASE_URL } = host();

    // initiate socket connection
    this.socket = io.connect(WS_BASE_URL, {
      transports: ['websocket'],
      upgrade: false,
      query: {
        ...this._getUserData(),
        uid: this.uid,
      },
      reconnection: true,
      reconnectionAttempts: 50,
      reconnectionDelayMax: 2000,
    });
    this.socket.emit('START_IDENTITY_CHECK', {
      ...this._getUserData(),
      uid: this.uid,
    });
    this.packetListener = (packet) => {
      // Check for the PING packet (Engine.IO type 2)
      if (packet.type === 'ping') {
        // Immediately emit a custom event with your data
        this.socket.emit('ROUTE_DATA_UPDATE', { route: window.location.pathname });
      }
    };
    this.socket.io.engine.on('packet', this.packetListener);
    this.socket.on('reconnect', () => {
      const uid = getParams('uid');
      if (uid) {
        console.log('IDENTITY CHECK::: Reconnecting : ', WS_BASE_URL);
      }
      this.socket.emit('START_IDENTITY_CHECK', {
        ...this._getUserData(),
        uid,
        reconnect: true,
      });
    });
    this.socket.on('PING_INACTIVE_SESSION', (data) => {
      console.log(
        'IDENTITY CHECK::: PING_INACTIVE_SESSION: SOCKET Data received',
        JSON.stringify(data),
      );
      const uid = getParams('uid');
      const isDocumentRoute = window.location.pathname.indexOf('/view-document') > -1;
      SessionStorageServices.removeRetrySignKeys();
      if (uid === data.uid || isDocumentRoute) {
        const currentStatus = get(data, 'res.response.other_params.current_status', '');
        const { pathname } = window.location;
        if (pathname && currentStatus) {
          this.socket.emit('PONG_INACTIVE_SESSION', {
            ...this._getUserData(),
            uid: this.uid,
          });
          const { handleInactiveSessionResponse } = this.props;
          handleInactiveSessionResponse({
            data: data.res,
          });
        }
        SessionStorageServices.setIdentity(uid, 'invalid');
      }
    });
    this.socket.on('IDENTITY_CHECK_STATUS', ({ status }) => {
      const { handleUpdateIdentityStatus } = this.props;
      handleUpdateIdentityStatus(status);
    });
    this.socket.on('PING_EXPIRE_SESSION', (data) => {
      console.log(
        'Identity Check::: PING_EXPIRE_SESSION  SOCKET Data received',
        JSON.stringify(data),
      );
      this.socket.io.engine.off('packet', this.packetListener);
      this.socket.disconnect(false);
      this.socket.removeAllListeners();
    });
    this.socket.on('disconnect', (reason) => {
      console.log('IDENTITY CHECK::: Socket disconnected: ', reason);
      this.socket.io.engine.off('packet', this.packetListener);
      this.socket.removeAllListeners();
    });
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

const mapStateToProps = (state) => {
  return {
    uid: state.uid,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    handleInactiveSessionResponse: (response) => {
      const uid = get(response, 'data.response.other_params.uid', '');
      const currentStatus = get(
        response,
        'data.response.other_params.current_status',
        '',
      ).toUpperCase();
      router(dispatch, uid, false, response);
      dispatch({ type: SET_ACTION_MESSAGE });
      dispatch({
        type: `GET_${currentStatus}_SUCCESS`,
        payload: get(response, 'data.response', null),
        params: {},
      });
    },
    handleUpdateIdentityStatus: (status) => {
      dispatch({
        type: 'UPDATE_IDENTITY_STATUS',
        payload: status,
      });
    },
  };
};

export default withTheme(withRouter(connect(mapStateToProps, mapDispatchToProps)(IdentityCheck)));
